import React from "react";
import {
  Container,
  CVButton,
  HomePage,
  NameCon,
  PersonalInfo,
  ProfilePic,
  ProfileWrapper,
} from "../styles/home";
import ProfileImg from "../assets/profile.png";
import Portfolio from "./portfolio";
import resume from "../assets/resume.pdf";
import { StyledArrow } from "../components/arrow";
import SocialButtons from "../components/social-buttons";
import { Marque } from "../components/marquee";
import { MarqueePlain } from "../components/samle";

const Home = () => {
  return (
    <HomePage>
      <Container>
        <NameCon>
          <p>HELLO! I AM ILYOSJON INOMJONOV</p>
        </NameCon>
        <ProfileWrapper>
          <p style={{ color: "black", zIndex: 1, fontFamily: "Neue Machina" }}>
            Creative designer <br />& Developer
          </p>
          <ProfilePic src={ProfileImg} width={300} />
        </ProfileWrapper>
        <PersonalInfo>
          <CVButton href={resume} download={"Resume-Ilyosjon"}>
            <p>
              Download CV{" "}
              <div>
                <StyledArrow />
              </div>
            </p>
          </CVButton>
          <SocialButtons />
        </PersonalInfo>
        <Marque />
        <MarqueePlain />
      </Container>
      <Portfolio />
    </HomePage>
  );
};

export default Home;
